import { ColDef } from 'ag-grid-community';
import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import '../../../style.scss';

import { memo } from 'react';
import { IDetailGroup } from '../../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { ISelectOption } from '../../../../../../api/selectOptions/selectOptionsApi';
import { IDataFilterGroupList, IPagination } from '../../AddGroup/AddNewGroup';
import EG_PrivateNoAutomatic from '../PrivateEditGroup/EG_PrivateNoAutomatic';
import EG_Decentralization from './components/EG_Decentralization';
import { ISelectedUserAccount } from '../ConditionEdit/EG_Decentralization';
import { ISelectedCustomer } from '../EditGroup';


interface props {
    sLCategoryCar: ISelectOption[]

    memoizedColumnDefs?: ColDef<any, any>[]
    tableDataNoCondCustomer?: any[]

    paginationCustomer: IPagination
    inforGroup?: IDetailGroup
    selectedIdCustomerV9: ISelectedCustomer[]
    selectedIdAccount: ISelectedUserAccount[]
    setSelectedIdCustomerV9: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>>

    setSelectedIdAccount: React.Dispatch<React.SetStateAction<ISelectedUserAccount[]>>
    onPaginationCustomers: (page: number, pageSize: number) => void;

    //Kh không dk
    paginationNoCondCustomerManual: IPagination
    dataFilterListNoCondCustomers: IDataFilterGroupList
    dataFilterListNoCondCustomerManual: IDataFilterGroupList
    selectedIdNoCondCustomerManual: Set<number>
    tableDataNoCondCustomerManual: any[]

    setDataFilterListNoCondCustomers: (dataFilterList: IDataFilterGroupList) => void;

    setDataFilterListNoCondCustomerManual: (dataFilterList: IDataFilterGroupList) => void
    handleChangeNoCondSelectIdCustomerManual: (data: Set<number>) => void
    onPaginationNoCondChangeManual?: ((page: number, pageSize: number) => void)

    //Kh không dk
}


const EG_SharingNoAutomatic: React.FC<props> = ({
    sLCategoryCar,
    memoizedColumnDefs, tableDataNoCondCustomer,
    paginationCustomer, inforGroup, selectedIdCustomerV9, selectedIdAccount,
    setSelectedIdCustomerV9,
    setDataFilterListNoCondCustomers,
    setSelectedIdAccount,
    onPaginationCustomers,

    //Kh không dk
    paginationNoCondCustomerManual,
    dataFilterListNoCondCustomers,
    dataFilterListNoCondCustomerManual,
    selectedIdNoCondCustomerManual,
    tableDataNoCondCustomerManual,

    setDataFilterListNoCondCustomerManual,
    onPaginationNoCondChangeManual,
    handleChangeNoCondSelectIdCustomerManual,
    //Kh không dk
}) => {

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span className='custom-page-css text-base font-regular'>Danh sách khách hàng</span>,
            children:
                <EG_PrivateNoAutomatic
                    sLCategoryCar={sLCategoryCar}

                    memoizedColumnDefs={memoizedColumnDefs}
                    tableDataNoCondCustomer={tableDataNoCondCustomer}

                    paginationCustomer={paginationCustomer}
                    dataFilterListNoCondCustomers={dataFilterListNoCondCustomers}
                    // selectedIdCustomer={selectedIdCustomer}
                    selectedIdCustomerV9={selectedIdCustomerV9}

                    setSelectedIdCustomerV9={setSelectedIdCustomerV9}

                    setDataFilterListNoCondCustomers={setDataFilterListNoCondCustomers}
                    onPaginationCustomers={onPaginationCustomers}

                    //Kh không dk
                    paginationNoCondCustomerManual={paginationNoCondCustomerManual}
                    dataFilterListNoCondCustomerManual={dataFilterListNoCondCustomerManual}
                    selectedIdNoCondCustomerManual={selectedIdNoCondCustomerManual}
                    tableDataNoCondCustomerManual={tableDataNoCondCustomerManual}


                    setDataFilterListNoCondCustomerManual={setDataFilterListNoCondCustomerManual}
                    onPaginationNoCondChangeManual={onPaginationNoCondChangeManual}
                    handleChangeNoCondSelectIdCustomerManual={handleChangeNoCondSelectIdCustomerManual}
                //Kh không dk
                />,
        },
        {
            key: '2',
            label: <span className='custom-page-css text-base font-regular'>Phân quyền</span>,
            children:
                <EG_Decentralization

                    inforGroup={inforGroup}

                    setSelectedIdAccount={setSelectedIdAccount}
                />,
        },
    ];

    const onChange = (key: string) => {
        // console.log(key);
    };

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
            <div className="custom-page-css w-full flex gap-2 items-center">
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='w-full' />

            </div>

        </div>
    )
}

export default memo(EG_SharingNoAutomatic) 
